import { Input, validateInput, ValidationFunction } from "basis";
import { components } from "library/api/card-management-service.generated";

// See: https://en.wikipedia.org/wiki/Telephone_numbers_in_Australia#Mobile_phones
const AU_MOBILE_NUMBER_REGEX = /^\s*0?\s*[45](\s*\d){8}\s*$/;

// Note:
//    We have mobile number validation functions in library/formValidation.js,
//    but those support a country code which we don't want to support here.
const validateAuMobileNumber: ValidationFunction<typeof Input> = (
  value,
  inputProps,
) => {
  const errors = validateInput(value, inputProps);

  if (errors) {
    return errors;
  }

  if (AU_MOBILE_NUMBER_REGEX.test(value) === false) {
    return "Invalid mobile number";
  }

  return null;
};

// See: https://en.wikipedia.org/wiki/Telephone_numbers_in_New_Zealand#Mobile_phones
const NZ_MOBILE_NUMBER_REGEX = /^\s*0?\s*2(\s*\d){7,9}\s*$/;

const validateNzMobileNumber: ValidationFunction<typeof Input> = (
  value,
  inputProps,
) => {
  const errors = validateInput(value, inputProps);

  if (errors) {
    return errors;
  }

  if (NZ_MOBILE_NUMBER_REGEX.test(value) === false) {
    return "Invalid mobile number";
  }

  return null;
};

export const validateMobileNumberMap = {
  AUSTRALIA: validateAuMobileNumber,
  "NEW ZEALAND": validateNzMobileNumber,
};

export function getFullMobileNumber(
  countryCodePrefix: string,
  mobileNumber: string,
): string {
  let result = mobileNumber.replace(/\D/g, ""); // remove all non-digits

  if (result[0] === "0") {
    result = result.slice(1); // remove leading 0
  }

  return `${countryCodePrefix}${result}`;
}

export const getVerifyLinks = (
  links: components["schemas"]["HATEOASLink"][] = [],
) => {
  const updatePhoneVerify = links.find(
    (link) => link.rel === "update_phone_details_verify",
  )?.href;

  if (!updatePhoneVerify) {
    console.error("Verify phone details url wasn't supplied");
    throw new window.Error("Invalid response");
  }

  const updatePhoneResend = links.find(
    (link) => link.rel === "update_phone_details_resend_otp",
  )?.href;

  if (!updatePhoneResend) {
    console.error(
      "Resend verification code for phone details url wasn't supplied",
    );
    throw new window.Error("Invalid response");
  }

  return { updatePhoneVerify, updatePhoneResend };
};
